import React, { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Chip } from "@mui/material";
import axiosInstance from "../../../utils/axiosInstance";
import {
  channelDetails,
  createChannel,
  fetchadminSuppArray,
  fetchAllBot,
  updateChannel,
} from "../../shared/ApiEndpoint";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { message, notification } from "antd";
import { CurrentUserId } from "../../shared/shared";

export default function MultiSelectWithDisplay() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const channelId = searchParams.get("id");
  const [userList, setUserList] = useState([
    {
      id: 0,
      name: "",
    },
  ]);
  const [adminList, setAdminList] = useState([
    {
      id: 0,
      name: "",
    },
  ]);
  const [botList, setBotList] = useState([
    {
      id: 0,
      name: "",
    }
  ]);
  const [errorValidate, setErrorValidate] = useState({
    channel_name: false,
    channel_desc: false,
    adminInputArray: false,
    supportInputArray: false,
    botSelectArray:false
  });
  const [admins, setAdmins] = useState([]);
  const [supportPersons, setSupportPersons] = useState([]);
  const [bots,setBots]=useState([]);
  const [chanelName, setChannelName] = useState("");
  const [channelDescription, setChannelDescription] = useState("");

  useEffect(() => {
    handlerolesArray("admin");
    handlerolesArray("support_role");
    handleGetBot();
  }, []);
  useEffect(() => {
    if (channelId) {
      botresponse(channelId);
    }
  }, [channelId]);

  const botresponse = async (channel_id) => {
    const resp = await axiosInstance.get(`${channelDetails}/${channel_id}`, {
      withCredentials: true,
    });

    if (resp?.status === 200) {
      setChannelName(resp?.data?.channel_name || "");
      setChannelDescription(resp?.data?.channel_desc || "");
      setAdmins(resp?.data?.admins || []); // defaults to [] if undefined/null
      setSupportPersons(resp?.data?.support_persons || []);
      setBots(resp?.data?.bot_id ? [resp?.data?.bot_id]:[]);
    }
  };
  const handleDelete = (setState, idToRemove) => {
    setState((prev) => prev.filter((id) => id !== idToRemove));
  };

  const handleOnChange = (key, setter) => (e) => {
    const event = e.target.value;
    setter(event);

    if (event.trim() !== "") {
      setErrorValidate((prev) => ({
        ...prev,
        [key]: false,
      }));
    }
  };
  const handleAutoCompleteChange = (setter, errorKey) => (e, value) => {
    const ids = value.map((v) => v.id);
    setter(ids); // Update state (like setAdmins)

    // Clear error if at least one is selected
    if (ids.length > 0) {
      setErrorValidate((prev) => ({
        ...prev,
        [errorKey]: false,
      }));
    }
  };
  const handleBotsAutoCompleteChange = (setState, fieldName) => (event, value) => {
  const selectedId = value ? [value.id] : []; // Always wrap in array for consistency
  setState(selectedId);

  if(selectedId){
    setErrorValidate((prev) => ({
      ...prev,
      [fieldName]: false,
    }));
  }
};


  const handlerolesArray = async (role) => {
    try {
      const resp = await axiosInstance.get(fetchadminSuppArray, {
        params: { role }, 
        withCredentials: true,
      });
      if (resp?.status === 200) {
        if (role === "admin") {
          const data = resp.data.map((item) => ({
            id: item.id,
            name: item.name,
          }));
          setAdminList(data);
        } else if (role === "support_role") {
          const data = resp.data.map((item) => ({
            id: item.id,
            name: item.name,
          }));
          setUserList(data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

 const handleGetBot = async () => {
  try {
    const resp = await axiosInstance.get(fetchAllBot, {
      withCredentials: true,
    });

    if (resp?.status === 200) {
      const data = resp.data.map((item) => ({
        id: item._id,
        name: item.bot_name,
      }));
      setBotList(data);
    }
  } catch (error) {
    console.log("Error fetching bots:", error);
  }
};

  const handleSave = async () => {
    let isValid = true;

    const validations = {
      adminInputArray: admins.length === 0,
      supportInputArray: supportPersons.length === 0,
      channel_name: !chanelName,
      channel_desc: !channelDescription,
      botSelectArray:bots.length===0
    };
    Object.entries(validations).forEach(([key, hasError]) => {
      if (hasError) isValid = false;
    });

    setErrorValidate((prev) => ({
      ...prev,
      ...validations,
    }));
    if (!isValid) return;
    try {
      const payload = {
        ...(chanelName && { channel_name: chanelName }),
        ...(channelDescription && { channel_desc: channelDescription }),
        ...(admins.length > 0 && { admins }),
        ...(supportPersons.length > 0 && { support_persons: supportPersons }),
        ...(channelId && { channel_id: channelId }),
        ...(CurrentUserId && { user_id: CurrentUserId }),
        ...(bots.length > 0 && {bot_id:bots[0] }),
      };

      let resp;
      if (channelId) {
        resp = await axiosInstance.put(updateChannel, payload, {
          withCredentials: true,
        });
      } else {
        resp = await axiosInstance.post(createChannel, payload, {
          withCredentials: true,
        });
      }
      if (resp.status === 200) {
        const msg = channelId
          ? "Channel updated successfully"
          : "Channel created successfully";
        notification.success({
        key: 'channelcreate-success',
        description: msg,
        placement: 'topRight',
      });

        // Clear all fields
        setChannelName("");
        setChannelDescription("");
        setAdmins([]);
        setSupportPersons([]);
        setBots([]);
        navigate("/channeldetails");
      }
    } catch (error) {
      const errMsg = error?.response?.data?.detail || "Something went wrong";

      if (error?.response?.status === 400) {
        message.error(`❗ ${errMsg}`);
      } else {
        message.error("🚫 Server Error: Failed to create channel");
      }

      console.error("Channel creation error:", error);
    }
  };
console.log(bots)
  return (
    <div className="container mt-4">
      <div className="row mb-4">
        <div className="col-md-6">
          <label className="form-label">Channel Name</label>
          <input
            type="text"
            className="form-control form-control-lg"
            placeholder="Enter Channel Name"
            value={chanelName}
            onChange={handleOnChange("channel_name", setChannelName)}
          />
          {errorValidate.channel_name && (
            <span className="text-danger">Channel Name is required</span>
          )}
        </div>

        <div className="col-md-6">
          <label className="form-label">Channel Description</label>
          <input
            type="text"
            className="form-control form-control-lg"
            placeholder="Enter Channel Description"
            value={channelDescription}
            onChange={handleOnChange("channel_desc", setChannelDescription)}
          />
          {errorValidate.channel_desc && (
            <span className="text-danger">Channel Description is required</span>
          )}
        </div>
      </div>

      <div className="row">
        {/* Admin Selector */}
        <div className="col-md-6 mb-3">
          <Autocomplete
            multiple
            options={adminList}
            getOptionLabel={(option) => option.name}
            value={adminList.filter((admin) => admins.includes(admin.id))} // Convert IDs back to objects for display
            onChange={handleAutoCompleteChange(setAdmins, "adminInputArray")} // Store only IDs
            disableClearable
            renderTags={() => null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Admins"
                placeholder="Admins"
              />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
          {errorValidate.adminInputArray && (
            <p className="text-danger">Please select at least one admin</p>
          )}
          {admins.length > 0 && (
            <div className="border rounded p-2 mt-2 d-flex flex-wrap gap-2">
              <strong className="w-100 mb-1">Selected Admins:</strong>
              {admins.map((id) => {
                const user = adminList.find((admin) => admin.id === id);
                return (
                  <Chip
                    key={id}
                    label={user?.name || ""}
                    onDelete={() => handleDelete(setAdmins, id)}
                    color="primary"
                    variant="outlined"
                  />
                );
              })}
            </div>
          )}
        </div>

        {/* Support Person Selector */}
        <div className="col-md-6 mb-3">
          <Autocomplete
            multiple
            options={userList}
            getOptionLabel={(option) => option.name}
            value={userList.filter((user) => supportPersons.includes(user.id))}
            onChange={handleAutoCompleteChange(
              setSupportPersons,
              "supportInputArray"
            )}
            disableClearable
            renderTags={() => null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Support Persons"
                placeholder="Support"
              />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
          {errorValidate.supportInputArray && (
            <p className="text-danger">
              Please select at least one support person
            </p>
          )}

          {supportPersons.length > 0 && (
            <div className="border rounded p-2 mt-2 d-flex flex-wrap gap-2">
              <strong className="w-100 mb-1">Selected Support Persons:</strong>
              {supportPersons.map((id) => {
                const user = userList.find((u) => u.id === id);
                return (
                  <Chip
                    key={id}
                    label={user?.name || ""}
                    onDelete={() => handleDelete(setSupportPersons, id)}
                    color="secondary"
                    variant="outlined"
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className="row">
               <div className="col-md-6 mb-3">
          <Autocomplete
  options={botList}
  getOptionLabel={(option) => option.name}
  value={botList.find((user) => user.id === bots[0]) || null}
  onChange={handleBotsAutoCompleteChange(setBots, "botSelectArray")}
  disableClearable
  renderInput={(params) => (
    <TextField {...params} label="Select Bots" placeholder="Bots" />
  )}
  isOptionEqualToValue={(option, value) => option.id === value.id}
/>
 {errorValidate.botSelectArray && (
            <span className="text-danger">Please select a bot</span>
          )}

{bots.length > 0 && (
  <div className="border rounded p-2 mt-2 d-flex flex-wrap gap-2">
    <strong className="w-100 mb-1">Selected Bot:</strong>
    {(() => {
      const user = botList.find((u) => u.id === bots[0]);
      return user ? (
        <Chip
          key={user.id}
          label={user.name}
          onDelete={() => setBots([])}
          color="secondary"
          variant="outlined"
        />
      ) : null;
    })()}
  </div>
)}

        </div>
      </div>
      <div className="d-flex justify-content-end mt-4">
        <button className="btn btn-success px-4" onClick={handleSave}>
          {channelId ? "Update Channel" : "Create Channel"}
        </button>
      </div>
    </div>
  );
}
 